module.exports = __webpack_public_path__ + "static/media/l28_thumb.2300750b.webp";